<div *ngIf="show" @fadeInOut class="dialog-progress-container">
  <div (click)="cancel.emit()" class="dialog-background"></div>

<!--  TODO: vertical scroll for long dialog height-->
  <div class="dialog-wrapper">
    <div class="dialog-progress">
      <div class="content-wrapper">
        <ng-content></ng-content>
      </div>
      <div class="progress-column">
        <div class="progress-header">
          {{progressTitle}}
        </div>

        <div class="progress-items">
          <div *ngFor="let item of labels; let i = index; let last = last"
               [ngClass]="{'completed': isLabelCompleted(i), 'active': progress === i}"
               class="progress-item"
          >
            <div class="checker">
              <div class="background"></div>
              <span></span>
            </div>
            <div [ngClass]="{last: last, locked: i > maxProgress}" class="progress-label">
              {{item}}
            </div>
          </div>
          <ng-container *ngIf="labels.length === 1">
            <div class="progress-item">
              <div class="checker">
                <div class="background"></div>
                <span></span>
              </div>
              <div class="progress-label">
                <img src="/assets/icons/icon-vertical-line.svg" />
              </div>
            </div>
            <div class="progress-item">
              <div class="checker">
                <div class="background"></div>
                <span></span>
              </div>
              <div class="progress-label">
                <img src="/assets/icons/icon-vertical-line.svg" />
              </div>
            </div>
          </ng-container>
        </div>

      </div>
    </div>
  </div>

</div>
